<template>
    <div class="LiquidationTimeline">
      <LiquidationTimeline/>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import LiquidationTimeline from '@/components/AdminLiquidationTimeline.vue'
  
  export default {
    name: 'admin-liquidation-timeline-view',
    components: {
      LiquidationTimeline
    }
  }
  </script>
  